import { io, type Socket } from 'socket.io-client';
import { getToken, type ChatMessage } from './api';

let socket: Socket | null = null;

/** One live connection per app session, shared by all screens. Reconnects by itself. */
export function getSocket(): Socket | null {
  const token = getToken();
  if (!token) return null;
  if (!socket) {
    const base = import.meta.env.VITE_API_URL ? new URL(import.meta.env.VITE_API_URL, location.href).origin : undefined;
    socket = io(base ?? '/', { path: '/api/socket.io', auth: { token }, transports: ['websocket', 'polling'] });
  }
  return socket;
}

export type MessageEvent = { conversationId: string; message: ChatMessage };
